export enum DeepseekModels {
  DEEPSEEK_V3 = "deepseek-v3",
}

export const DeepseekModelsEnabled = [DeepseekModels.DEEPSEEK_V3]
